import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
export default function Status() {
    const location = useLocation();
    const navigate = useNavigate();
    const query = new URLSearchParams(location.search);
    const confirmStatus = query.get("status");
    const backtopath = query.get("apptype");
    const FinalnavigationPath =
        backtopath === "InspectionFinal"
            ? "/FinalStatus"
            : backtopath === "DeficiencyFinal"
                ? "/DeficiencyFinalStatus"
                : backtopath === "physical"
                    ? "/InspectionFinalStatus"
                    : "/FinalStatus"; // default fallback

    console.log("FinalnavigationPath", FinalnavigationPath);

    useEffect(() => {
        handleVacancyResponse();
    }, []);
    const handleVacancyResponse = () => {
        if (confirmStatus === "S") {
            Swal.fire({
                title: "E-signed Successfully!",
                icon: "success",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "OK",
                backdrop: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then(() => navigate(FinalnavigationPath));
        } else if (confirmStatus === "F") {
            Swal.fire({
                title: "E-sign Failed!",
                text: "Please try again.",
                icon: "error",
                confirmButtonColor: "#d33",
                confirmButtonText: "OK",
                backdrop: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then(() => navigate(FinalnavigationPath));
        } else {
            Swal.fire({
                title: "Invalid Response",
                text: "Something went wrong.",
                icon: "warning",
                confirmButtonText: "Go Back",
                backdrop: false,
            }).then(() => navigate(FinalnavigationPath));
        }
    };
    return <React.Fragment />;
}
